import './App.css';
import Navbar from './Components/Navbar';
import TextForm from './Components/TextForm';
import About from './Components/About';
import React, { useState } from 'react';
import Alert from './Components/Alert';
import {
  BrowserRouter as Router,
  Route,
  Routes
} from "react-router-dom";

function App() {
  const [mode, setMode] = useState("light");
  const [txarea, setTxarea] = useState(null);
  const [alert, setAlert] =useState(null);
  const showAlert =(message,type)=>{
    setAlert({
      msg:message,
      type:type
    })
    setTimeout(()=>{
      setAlert(null)
    },1500)
  }
  const removeBodyClasses=()=>{
    document.body.classList.remove('bg-light');
    document.body.classList.remove('bg-success');
    document.body.classList.remove('bg-warning');
    document.body.classList.remove('bg-dark');
    document.body.classList.remove('bg-primary');
  }


 

   const toggleMode = (cls) => {
    removeBodyClasses();
    document.title ="TextCase - Dark Mode"
    // document.body.classList.add("bg-"+cls);
    if(mode === 'light') {
      setMode("dark");
      setTxarea("black");
      document.body.style.backgroundColor = "#000000";
      document.body.style.color = "white";
      document.textarea.style.backgroundColor="black";
      showAlert("Dark Mode has been Enabled","success");
    }else{
      setMode("light");
      setTxarea("white");
      document.body.style.backgroundColor = "white";
      document.body.style.color = "Black";
      showAlert("Light Mode has been Enabled","success");
      document.title ="TextCase - Light Mode"
    }
  }
   const toggleNewMode = (cls) => {
    removeBodyClasses();
    document.body.classList.add("bg-"+cls);
    if(mode === 'light') {
      setTxarea(cls);
      setMode("dark");
      document.body.style.backgroundColor = cls;
      document.body.style.color = "white";
      showAlert(cls + " Mode has been Enabled",cls);
    }else{
      removeBodyClasses();
      setMode("light");
      setTxarea("light");
      document.body.style.backgroundColor = "white";
      document.body.style.color = "Black";
      showAlert("Light mode has been Enabled",cls);
    }
  }
  return (
    <>
      <Router>
          <Navbar title= "TextCase" mode ={mode} toggleNewMode={toggleNewMode} toggleMode={toggleMode}/>
          <Alert alert= {alert}/>
        <div className="container my-3">
            <Routes>
              <Route path="/about" element={<About txarea={txarea} mode ={mode} toggleNewMode={toggleNewMode}/>}></Route>
              <Route path="/" element={<TextForm txarea={txarea} showAlert={showAlert}heading= "Enter the text to analyze below" mode ={mode} />}></Route>
            </Routes>
        </div>
      </Router>
    </>
  );
}

export default App;
